<div *ngIf="!status.loaded">
    <app-spinner></app-spinner>
</div>
<div [class]="{ 'payments': true, 'payments-error': error.accountError }">

    <div class="alert alert-danger" *ngIf="status.loaded && (error.transactionsError || error.accountError)">
        {{ errorText }}
    </div>
    <div class="payments__header" *ngIf="status.loaded && !error.accountError">
        <p class="payments__summary">
            <strong>{{config.currentBalanceText}}:</strong>
        </p>
        <p class="payments__balance">
            <span class="payments__column">
                <strong>{{balanceText}}</strong>
            </span>
            <span class="payments__column">
                <small class="payments__status payments__status--arrears"
                    *ngIf="balance < 0">{{config.inArrearsText}}</small>
                <small class="payments__status payments__status--credit"
                    *ngIf="balance > 0">{{config.inCreditText}}</small>
            </span>
        </p>
        <p class="payments__action" *ngIf="config.enablePaymentPage !== 'false'">
            <a href="/rent-and-charges/make-a-payment/" class="btn btn-primary">{{config.makeAPaymentText}}</a>
        </p>

        <app-payment-sub-account-breakdown></app-payment-sub-account-breakdown>
    </div>
    <form class="filter filter--show-button" *ngIf="status.loaded && !error.transactionsError">
        <fieldset class="filter__fieldset">
            <div class="filter__columns">
                <div class="filter__column btn-group" data-toggle="buttons">
                    <input id="filter-8" type="radio" name="filterRange" [checked]="currentFilter === 8">
                    <label for="filter-8" class="btn btn-secondary" (click)="filter(8)"
                        title="Show transactions from the previous 8 weeks">
                        <app-spinner *ngIf="!status.transactionsLoaded && this.currentFilter === 8"
                            class="transaction-spinner"></app-spinner>
                        8 weeks
                    </label>
                    <input id="filter-26" type="radio" name="filterRange" [checked]="currentFilter === 26">
                    <label for="filter-26" class="btn btn-secondary" (click)="filter(26)"
                        title="Show transactions from the previous 6 months">
                        <app-spinner *ngIf="!status.transactionsLoaded && this.currentFilter === 26"
                            class="transaction-spinner"></app-spinner>
                        6 months
                    </label>
                    <input id="filter-56" type="radio" name="filterRange" [checked]="currentFilter === 56">
                    <label for="filter-56" class="btn btn-secondary" (click)="filter(56)"
                        title="Show transactions from the previous 13 months">
                        <app-spinner *ngIf="!status.transactionsLoaded && this.currentFilter === 56"
                            class="transaction-spinner"></app-spinner>
                        13 months
                    </label>
                </div>
                <div class="filter__column filter__column--button">
                    <a (click)="trackDownload()" [href]="downloadUrl" target="_blank"
                        class="btn btn-block btn-tertiary btn-download-transactions">
                        <i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{config.downloadTransactionsText}}
                    </a>
                </div>
            </div>
        </fieldset>
    </form>
    <table id="transaction-history" class="payments__table table table-striped"
        *ngIf="status.loaded && !error.transactionsError">
        <thead>
            <tr>
                <th class="col-xs-4 col-md-6">{{config.detailsText}}</th>
                <th class="col-xs-4 col-md-3">{{config.amountText}}</th>
                <th class="col-xs-4 col-md-3">{{config.balanceText}}</th>
            </tr>
        </thead>
        <tbody>
            <tr class="payment" *ngFor="let transaction of transactions">
                <td class="col-xs-4 col-md-6">
                    <p class="payment__caption">{{transaction.dateText}}</p>
                    <p class="payment__description">{{transaction.description}}</p>
                </td>
                <td class="col-xs-4 col-md-3">
                    <p class="payment__amount">{{transaction.creditText}}</p>
                </td>
                <td class="col-xs-4 col-md-3">
                    <p class="payment__balance" *ngIf="transaction.balance === 0">
                        {{transaction.balanceText}}</p>
                    <p class="payment__balance payment__balance--credit" *ngIf="transaction.balance > 0">
                        {{transaction.balanceText}}</p>
                    <p class="payment__balance payment__balance--arrears" *ngIf="transaction.balance < 0">
                        {{transaction.balanceText}}</p>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="payments__footer"
        *ngIf="status.loaded && !error.accountError && !(isLeaseholder && charges.next === 0)">
        <p class="payments__summary">
            <strong>{{charges.frequency}}:</strong>
        </p>
        <p class="payments__balance">
            <span class="payments__column">
                <strong>{{charges.next}}</strong>
            </span>
        </p>
        <app-payment-balance-breakdown></app-payment-balance-breakdown>
    </div>
</div>